import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Failover: recoger token traspasado entre orígenes vía fragmento de URL
if (window.location.hash && window.location.hash.startsWith('#mkfo=')) {
  const tok = decodeURIComponent(window.location.hash.slice(6));
  if (tok && /^[\w-]+\.[\w-]+\.[\w-]+$/.test(tok)) localStorage.setItem('token', tok);
  window.history.replaceState(null, '', window.location.pathname + window.location.search);
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
